var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-meters-container"},[_c('Contests'),_c('Projects'),_c('ToWin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }